import React, { useContext } from 'react';
import TabView from '../shared/TabView';
import Cookies from 'js-cookie';
import { SettingsContext } from '../SettingsContext';
import { STATUS_BAR_HEIGHT } from '../StatusBar';

const apiUrl = process.env.REACT_APP_API_URL || 'https://scripthub.serviceorderhub.com/dashboardapi';
const token = Cookies.get('token');

const tabLabels = ['Sphinx Docs', 'API Docs'];
const tabContents = [
  <iframe
    key="sphinx"
    src={`${apiUrl}/docs/sphinx/`}
    title="Sphinx Documentation"
    style={{ width: '100%', height: '100%', border: 'none', background: '#fff' }}
  />,
  <iframe
    key="apidocs"
    src={`${apiUrl}/docs/swagger/swagger-ui.html`}
    title="API Documentation"
    style={{ width: '100%', height: '100%', border: 'none', background: '#fff' }}
  />
];

const Back = () => {
  const { useSmallSidebar, autoHideSidebar, isSidebarOpen } = useContext(SettingsContext);
  // Sidebar width logic must match Sidebar.js
  const sidebarWidth = autoHideSidebar && !isSidebarOpen ? 0 : (useSmallSidebar ? 120 : 180);

  return (
    <div // Main container
      style={{
        position: 'fixed',
        top: 0,
        left: sidebarWidth,
        width: `calc(100vw - ${sidebarWidth}px)`,
        height: '100vh',
        paddingBottom: `${STATUS_BAR_HEIGHT}px`,
        boxSizing: 'border-box',
        background: '#1e1e1e',
        zIndex: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* TabView Wrapper */}
      <div style={{ flex: 1, overflow: 'hidden', display: 'flex' }}>
        <TabView
          tabLabels={tabLabels}
          tabContents={tabContents}
          variant="small"
          customSmallDimensions={{ minHeight: '100%', height: '100%', width: '100%' }} // Consider if this is still needed or conflicts
          disableUrlUpdate={true}
          sx={{
            flex: 1, // TabView grows to fill its flex parent (the wrapper div)
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden', // Prevent TabView's internal content from overflowing
            '& .tab-content-container': {
              flex: 1, // Content area takes remaining space within TabView
              overflow: 'hidden',
            },
          }}
        />
      </div>
    </div>
  );
};

export default Back;
